import React from 'react';
import './Notifications.css';
import AmbientStage from '../components/AmbientStage';
import BottomNav from '../components/BottomNav';

const notifications = [
  {
    tag: 'Now',
    title: 'Smart factory demo starts in 15 minutes',
    body: 'Head to Hall A, machine lane 04. Your saved session is about to open.',
  },
  {
    tag: 'Ticket',
    title: 'Your digital pass was scanned',
    body: 'Gate 04 confirmed your entry at 6:12 PM. Enjoy the exhibition floor.',
  },
  {
    tag: 'Map',
    title: 'Crowd flow changed',
    body: 'Fastest route to the buyer lounge is now through the west corridor.',
  },
  {
    tag: 'Soon',
    title: 'Sustainable production talk',
    body: 'Studio C opens seating at 7:45 PM. Arrive early for front-row access.',
  },
];

function Notifications({ activeScreen, onNavigate }) {
  return (
    <AmbientStage className="notifications-screen">
      <header className="notifications-header">
        <p className="eyebrow">Notifications</p>
        <h2>Signals from the floor.</h2>
      </header>

      <section className="alert-hero" aria-label="Priority notification">
        <span>Priority</span>
        <strong>Hall A is entering live demo mode.</strong>
        <p>Machinery zone lights up at 6:30 PM. Your pass is already queued.</p>
      </section>

      <section className="notification-list" aria-label="Notification list">
        {notifications.map((item, index) => (
          <article className="notification-card" key={item.title}>
            <div className="notification-mark">
              <span>{index + 1}</span>
            </div>
            <div>
              <span className="notification-tag">{item.tag}</span>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </div>
          </article>
        ))}
      </section>

      <BottomNav activeScreen={activeScreen} onNavigate={onNavigate} />
    </AmbientStage>
  );
}

export default Notifications;
